// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Seed = require("./seed");
var $$Array = require("bs-platform/lib/js/array.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Theme = require("./theme");
var React = require("react");
var Network = require("./network");
var Storage = require("./storage");
var Caml_obj = require("bs-platform/lib/js/caml_obj.js");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Caml_primitive = require("bs-platform/lib/js/caml_primitive.js");
var X_iconSvg = require("./assets/x_icon.svg");
var Tipps_iconSvg = require("./assets/tipps_icon.svg");
var Dropdown_arrowSvg = require("./assets/dropdown_arrow.svg");
var Tipps_tricks_patternPng = require("./assets/tipps_tricks_pattern.png");

var card = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* [] */0
      ]
    ]);

var dashboard = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.textAlign(Css.center),
        /* :: */[
          Css.display(Css.flexBox),
          /* :: */[
            Css.flexDirection(Css.column),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.backgroundImage(/* `url */[
                      5843823,
                      Tipps_tricks_patternPng
                    ]),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.textAlign(Css.center),
        /* :: */[
          Css.display(Css.flexBox),
          /* :: */[
            Css.flexDirection(Css.column),
            /* [] */0
          ]
        ]
      ]
    ]);

var knowledgeBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.boxSizing(Css.borderBox),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* :: */[
                  Css.padding4(Css.px(0), Css.px(12), Css.px(2), Css.px(12)),
                  /* :: */[
                    Css.margin4(Css.px(40), Css.px(0), Css.px(20), Css.px(0)),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var workoutBoxInner = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.borderRadius(Css.px(10)),
              /* :: */[
                Css.boxShadow(/* Some */[Css.px(2)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(255, 191, 194, 0.29)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var workoutBoxHeader = Css.style(/* :: */[
      Css.minHeight(Css.px(80)),
      /* :: */[
        Css.position(Css.relative),
        /* :: */[
          Css.display(Css.flexBox),
          /* :: */[
            Css.flexDirection(Css.column),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.justifyContent(Css.center),
                /* :: */[
                  Css.background(/* `hex */[
                        5194459,
                        "FFFAFA"
                      ]),
                  /* :: */[
                    Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
                    /* :: */[
                      Css.padding2(Css.px(0), Css.px(0)),
                      /* :: */[
                        Css.width(/* `percent */[
                              -119887163,
                              100.0
                            ]),
                        /* :: */[
                          Css.borderBottom(Css.px(2), /* solid */12956715, Css.hex("FCEBEC")),
                          /* [] */0
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var tipps = Css.style(/* :: */[
      Css.top(/* `percent */[
            -119887163,
            50.0
          ]),
      /* :: */[
        Css.transforms(/* :: */[
              /* `translate */[
                -914368690,
                /* tuple */[
                  Css.px(0),
                  /* `percent */[
                    -119887163,
                    -50.0
                  ]
                ]
              ],
              /* :: */[
                /* `scale */[
                  -120664438,
                  /* tuple */[
                    1.4,
                    1.4
                  ]
                ],
                /* [] */0
              ]
            ]),
        /* :: */[
          Css.position(/* absolute */-1013592457),
          /* :: */[
            Css.left(Css.px(14)),
            /* [] */0
          ]
        ]
      ]
    ]);

var headHeader = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(52), Css.px(0), Css.px(52)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(5)),
        /* [] */0
      ]
    ]);

var subHeader = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(0)),
        /* :: */[
          Css.fontSize(Css.px(22)),
          /* [] */0
        ]
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(10)),
      /* :: */[
        Css.fontWeight(700),
        /* [] */0
      ]
    ]);

var entryHeader = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.justifyContent(/* spaceBetween */516682146),
        /* :: */[
          Css.fontWeight(700),
          /* :: */[
            Css.cursor(/* pointer */-786317123),
            /* :: */[
              Css.background(/* `hex */[
                    5194459,
                    "FFF"
                  ]),
              /* :: */[
                Css.padding4(Css.px(10), Css.px(10), Css.px(10), Css.px(10)),
                /* :: */[
                  Css.boxSizing(/* borderBox */9307263),
                  /* :: */[
                    Css.borderBottom(Css.px(1), /* solid */12956715, /* `hex */[
                          5194459,
                          "FCEBEC"
                        ]),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var entryHeaderWhite = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.justifyContent(/* spaceBetween */516682146),
        /* :: */[
          Css.fontWeight(700),
          /* :: */[
            Css.cursor(/* pointer */-786317123),
            /* :: */[
              Css.background(/* `hex */[
                    5194459,
                    "FFFAFA"
                  ]),
              /* :: */[
                Css.padding4(Css.px(10), Css.px(10), Css.px(10), Css.px(10)),
                /* :: */[
                  Css.boxSizing(/* borderBox */9307263),
                  /* :: */[
                    Css.borderBottom(Css.px(1), /* solid */12956715, /* `hex */[
                          5194459,
                          "FCEBEC"
                        ]),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.textAlign(/* left */-944764921),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* :: */[
            Css.margin2(Css.px(10), Css.px(0)),
            /* :: */[
              Css.color(/* `hex */[
                    5194459,
                    "FF328C"
                  ]),
              /* :: */[
                Css.fontWeight(700),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var someText = Css.style(/* :: */[
      Css.textAlign(/* center */98248149),
      /* :: */[
        Css.fontSize(Theme.standardFontSize),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* :: */[
            Css.margin2(Css.px(10), Css.px(0)),
            /* :: */[
              Css.color(/* `hex */[
                    5194459,
                    "FF328C"
                  ]),
              /* :: */[
                Css.fontWeight(700),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

function settingButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(12.0)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.margin4(Css.px(30), Css.px(8), Css.px(10), Css.px(8)),
                  /* :: */[
                    Css.maxWidth(Css.em(13.0)),
                    Theme.greenButtonRaw
                  ]
                ]
              ]
            ]);
}

var arrowIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(8)),
      /* [] */0
    ]);

var xIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(8)),
      /* [] */0
    ]);

var entryBox = Css.style(/* :: */[
      Css.padding2(Css.px(18), Css.px(10)),
      /* :: */[
        Css.background(Css.white),
        /* :: */[
          Css.borderBottom(Css.px(1), /* solid */12956715, /* `hex */[
                5194459,
                "FCEBEC"
              ]),
          /* :: */[
            Css.textAlign(/* left */-944764921),
            /* :: */[
              Css.whiteSpace(/* preLine */538440119),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var Styles = /* module */[
  /* card */card,
  /* dashboard */dashboard,
  /* flexList */flexList,
  /* knowledgeBox */knowledgeBox,
  /* workoutBoxInner */workoutBoxInner,
  /* workoutBoxHeader */workoutBoxHeader,
  /* tipps */tipps,
  /* headHeader */headHeader,
  /* subHeader */subHeader,
  /* inputHeader */inputHeader,
  /* entryHeader */entryHeader,
  /* entryHeaderWhite */entryHeaderWhite,
  /* inputField */inputField,
  /* someLink */someLink,
  /* someText */someText,
  /* settingButton */settingButton,
  /* arrowIcon */arrowIcon,
  /* xIcon */xIcon,
  /* entryBox */entryBox
];

function text(prim) {
  return prim;
}

var component = ReasonReact.reducerComponent("Knowledge");

function make() {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      Curry._1(self[/* send */4], /* MarkSeen */2);
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      var newArr = $$Array.copy(Seed.knowledgeEntries);
      $$Array.sort((function (x, y) {
              return Caml_primitive.caml_int_compare(y[/* id */0], x[/* id */0]);
            }), newArr);
      var match = +(self[/* state */2][/* fullDay */0] === 0);
      return React.createElement("div", {
                  className: dashboard
                }, React.createElement("div", {
                      className: knowledgeBox
                    }, React.createElement("div", {
                          className: workoutBoxInner
                        }, React.createElement("div", {
                              className: workoutBoxHeader
                            }, React.createElement("img", {
                                  className: tipps,
                                  alt: "Tipps",
                                  src: Tipps_iconSvg
                                }), React.createElement("h1", {
                                  className: headHeader
                                }, "Tipps & Tricks")), $$Array.mapi((function (i, el) {
                                var match = +(i % 2 === 0);
                                var styleCheck = match !== 0 ? entryHeader : entryHeaderWhite;
                                var match$1 = +((28 - self[/* state */2][/* fullDay */0] | 0) <= i);
                                if (match$1 !== 0) {
                                  var match$2 = Caml_obj.caml_equal(/* Some */[i], self[/* state */2][/* openEntry */1]);
                                  return React.createElement("div", {
                                              key: String(i),
                                              className: flexList
                                            }, match$2 !== 0 ? React.createElement("div", {
                                                    className: flexList
                                                  }, React.createElement("div", {
                                                        className: styleCheck,
                                                        onClick: (function () {
                                                            return Curry._1(self[/* send */4], /* CloseEntry */1);
                                                          })
                                                      }, React.createElement("div", {
                                                            className: someLink
                                                          }, "Tag " + (String(el[/* id */0]) + (": " + el[/* title */1]))), React.createElement("img", {
                                                            className: xIcon,
                                                            alt: "x",
                                                            src: X_iconSvg
                                                          })), React.createElement("div", {
                                                        className: entryBox
                                                      }, React.createElement("span", {
                                                            dangerouslySetInnerHTML: {
                                                              __html: Caml_array.caml_array_get(Seed.knowledgeEntries, (28 - i | 0) - 1 | 0)[/* content */2]
                                                            }
                                                          }))) : React.createElement("div", {
                                                    className: styleCheck,
                                                    onClick: (function () {
                                                        return Curry._1(self[/* send */4], /* OpenEntry */[i]);
                                                      })
                                                  }, React.createElement("div", {
                                                        className: someLink
                                                      }, "Tag " + (String(el[/* id */0]) + (": " + el[/* title */1]))), React.createElement("img", {
                                                        className: arrowIcon,
                                                        alt: "arrow",
                                                        src: Dropdown_arrowSvg
                                                      })));
                                } else {
                                  return null;
                                }
                              }), newArr), match !== 0 ? React.createElement("div", {
                                className: someText
                              }, "Anzeige der Wissenseinheiten erfolgt nach Programmstart. Bitte absolviere dafür das erste Workout. Täglich wird dir hier ein neuer Praxistipp freigeschaltet!") : null), React.createElement("button", {
                          className: settingButton(/* () */0),
                          onClick: (function () {
                              return ReasonReact.Router[/* push */0]("/dashboard");
                            })
                        }, "Dashboard")));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* fullDay */Storage.fullDayMax28(/* () */0),
              /* openEntry : None */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        switch (action) {
          case 0 : 
              return /* NoUpdate */0;
          case 1 : 
              return /* Update */Block.__(0, [/* record */[
                          /* fullDay */state[/* fullDay */0],
                          /* openEntry : None */0
                        ]]);
          case 2 : 
              return /* SideEffects */Block.__(2, [(function () {
                            return Network.storeKnowledgeRead(Storage.fullDayMax28(/* () */0));
                          })]);
          
        }
      } else {
        return /* Update */Block.__(0, [/* record */[
                    /* fullDay */state[/* fullDay */0],
                    /* openEntry : Some */[action[0]]
                  ]]);
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.component = component;
exports.make = make;
/* card Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/knowledge.re
// module id = 139
// module chunks = 0